<template>
  <div class="footer-content">
    --- {{ $t('message["1275"]') }} ---
  </div>
</template>
<script>
export default {
  data () {
    return {

    }
  }
}
</script>
<style lang="scss" scoped>
.footer-content {
  line-height: 44px;
  text-align: center;
  margin-top:8px;
  margin-bottom:20px;
  color: #b3b3b3;
}
</style>
